module.exports = __webpack_public_path__ + "assets/img/green.c38fc7fa.png";